import Content from "./content/Content";

const TeamSection = () => {
  return (
    <section className="team-section" id="program-directors">
      <Content />
    </section>
  );
};
export default TeamSection;
